// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { createProductFeedProductFeed } from "./product-feed.js";
export const createProductFeedExtensions = (client) => createProductFeedProductFeed(client);
export const productFeedOperations = [
    { method: "GET", path: "/product-feed", accessor: "productFeed.list" },
];
//# sourceMappingURL=index.js.map